import React, {useEffect, useMemo, useState} from 'react';
import {Form, InputGroup, Modal} from "react-bootstrap";
import {Controller, useForm} from 'react-hook-form';
import {useAddCompanyMutation, useEditCompanyMutation} from '../../redux/services/companyService';
import LoadingButtonWithForm from '../../components/LoadingButtonWithForm';
import {sweetAlert} from '../../utils';
import {responseError} from '../../helpers/responseHandler';
import PhoneInput from 'react-phone-input-2';

const AddCompanyModal = ({show, handleClose, isEdit}) => {
    const [isPassword, setIsPassword] = useState(true);
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState('');
    const [selectedState, setSelectedState] = useState('');

    let {
        control,
        register,
        handleSubmit,
        setValue,
        watch,
        reset,
        formState: {errors},
    } = useForm()

    const [addRequest, {isLoading: addLoading}] = useAddCompanyMutation()
    const [editRequest, {isLoading: editLoading}] = useEditCompanyMutation()


    const onSubmit = async (data) => {
        if (isEdit) {
            const newForm = {...data}
            await editRequest({id: isEdit?.id, newForm}).unwrap()
                .then((res) => {
                    if (res?.status) {
                        sweetAlert(res?.message, 'success')
                        // navigate(-1)
                        handleClose()
                    }
                })
                .catch((err) => {
                    responseError(err)
                })
        } else {
            const newForm = {...data}
            await addRequest(newForm).unwrap()
                .then((res) => {
                    if (res?.status) {
                        sweetAlert(res?.message, 'success')
                        // navigate(-1)
                        handleClose()
                    }
                })
                .catch((err) => {
                    responseError(err)
                })
        }
    }


    useEffect(() => {
        fetch('https://countriesnow.space/api/v0.1/countries/')
            .then((response) => response.json())
            .then((data) => {
                setCountries(data.data.map((country) => country.country));
            })
            .catch((error) => console.error('Error fetching countries:', error));
    }, []);

    const handleCountryChange = (country) => {
        setSelectedCountry(country);
        setSelectedState(''); // Reset state and city when country changes
        setCities([]);

        fetch(`https://countriesnow.space/api/v0.1/countries/states/q?country=${country}`)
            .then((response) => response.json())
            .then((data) => {
                setStates(data?.data?.states || []);
            })
            .catch((error) => console.error('Error fetching states:', error));
    };

    const handleStateChange = (state) => {
        setSelectedState(state);

        fetch(`https://countriesnow.space/api/v0.1/countries/state/cities/q?country=${selectedCountry || isEdit?.country}&state=${state}`)
            .then((response) => response.json())
            .then((data) => {
                setCities(data?.data || []);
            })
            .catch((error) => console.error('Error fetching cities:', error));
    };


    const country = useMemo(() => isEdit?.country, [])
    const statess = useMemo(() => isEdit?.state, [])

    useEffect(() => {
        if (country) {
            handleCountryChange(country)
        }
    }, [country])

    useEffect(() => {
        if (statess) {
            setTimeout(() => {
                handleStateChange(statess)
            }, [])
        }
    }, [statess])


    return (
        <>
            <Modal show={show} size="lg" onHide={handleClose}>
                <Modal.Header className="border-0" closeButton>
                    <Modal.Title className="h5">Create Company</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit(onSubmit)} id='company-status'>
                        <div className="row">
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Company Name:</Form.Label>

                                    <Controller
                                        name="company_name"
                                        control={control}
                                        defaultValue={isEdit?.company_name || ''}
                                        rules={{
                                            required: true
                                        }}
                                        render={({field}) => (
                                            <Form.Control
                                                {...field}
                                                type="text"
                                                isInvalid={errors.company_name}
                                            />
                                        )}
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>First Name:</Form.Label>
                                    <Controller
                                        name="first_name"
                                        control={control}
                                        defaultValue={isEdit?.first_name || ''}
                                        rules={{
                                            required: true
                                        }}
                                        render={({field}) => (
                                            <Form.Control
                                                {...field}
                                                type="text"
                                                isInvalid={errors.first_name}
                                            />
                                        )}
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Last Name:</Form.Label>
                                    <Controller
                                        name="last_name"
                                        control={control}
                                        defaultValue={isEdit?.last_name || ''}
                                        rules={{
                                            required: true
                                        }}
                                        render={({field}) => (
                                            <Form.Control
                                                {...field}
                                                type="text"
                                                isInvalid={errors.last_name}
                                            />
                                        )}
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Email:</Form.Label>
                                    <Controller
                                        name="email"
                                        control={control}
                                        defaultValue={isEdit?.email || ''}
                                        rules={{
                                            required: true
                                        }}
                                        render={({field}) => (
                                            <Form.Control
                                                {...field}
                                                type="email"
                                                isInvalid={errors.email}
                                                disabled={isEdit?.email ? true : false}
                                            />
                                        )}
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Country:</Form.Label>
                                    {/* <Form.Control type="text" name="country" placeholder="Enter country" /> */}
                                    <Controller
                                        name="country"
                                        control={control}
                                        defaultValue={isEdit?.country || ''}
                                        rules={{
                                            required: false
                                        }}
                                        render={({field}) => (
                                            <Form.Control
                                                {...field}
                                                className='form-select'
                                                as="select"
                                                name="country"
                                                value={field.value}
                                                onChange={(e) => {
                                                    field.onChange(e)
                                                    handleCountryChange(e.target.value)
                                                }}
                                            >
                                                <option value="">Select Country</option>
                                                {countries.map((country, index) => (
                                                    <option key={index} value={country}>{country}</option>
                                                ))}
                                            </Form.Control>
                                        )}
                                    />
                                </Form.Group>
                            </div>

                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>State:</Form.Label>
                                    <Controller
                                        name="state"
                                        control={control}
                                        defaultValue={isEdit?.state || ''}
                                        rules={{
                                            required: false
                                        }}
                                        render={({field}) => (
                                            <Form.Control
                                                {...field}
                                                className='form-select'
                                                as="select"
                                                name="state"
                                                value={field.value}
                                                onChange={(e) => {
                                                    field.onChange(e)
                                                    handleStateChange(e.target.value)
                                                }}
                                            >
                                                <option value="">Select State</option>
                                                {states.map((state, index) => (
                                                    <option key={index} value={state.name}>{state.name}</option>
                                                ))}
                                            </Form.Control>
                                        )}
                                    />

                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>City:</Form.Label>
                                    <Controller
                                        name="city"
                                        control={control}
                                        defaultValue={isEdit?.city || ''}
                                        rules={{
                                            required: false
                                        }}
                                        render={({field}) => (
                                            <Form.Control
                                                {...field}
                                                className='form-select'
                                                as="select"
                                                name="city"
                                            >
                                                <option value="">Select City</option>
                                                {cities.map((city, index) => (
                                                    <option key={index} value={city}>{city}</option>
                                                ))}
                                            </Form.Control>
                                        )}
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Phone:</Form.Label>
                                    <Controller
                                        name="phone"
                                        control={control}
                                        defaultValue={isEdit?.phone || '+1'}
                                        rules={{
                                            required: true
                                        }}
                                        render={({field}) => (
                                            <PhoneInput
                                                {...field}
                                                country={'us'} // Default country
                                                inputProps={{
                                                    name: 'phone',
                                                    required: true,
                                                    autoFocus: true,
                                                }}
                                            />
                                        )}
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Password:</Form.Label>
                                    <Controller
                                        name="password"
                                        control={control}
                                        defaultValue={isEdit?.password || ''}
                                        rules={{
                                            required: true
                                        }}
                                        render={({field}) => (
                                            <>
                                                <InputGroup className="mb-3">
                                                    <Form.Control
                                                        {...field}
                                                        type={isPassword ? 'password' : 'text'}
                                                        isInvalid={errors.password}
                                                        aria-describedby="basic-addon2"
                                                    />
                                                    <InputGroup.Text id="basic-addon2" type="button" onClick={() => setIsPassword(prev => !prev)}>
                                                        {isPassword ? <i class="fa fa-eye"/> : <i class="fa fa-eye-slash"/>}
                                                    </InputGroup.Text>
                                                </InputGroup>
                                            </>

                                            )}
                                        />
                                </Form.Group>
                            </div>
                            {/* <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Confirm Password:</Form.Label>
                                    <Form.Control type="password" name="confirmPassword" placeholder="Confirm password" />
                                </Form.Group>
                            </div> */}
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Zip Code:</Form.Label>
                                    <Controller
                                        name="zip"
                                        control={control}
                                        defaultValue={isEdit?.zip || ''}
                                        rules={{
                                            required: true
                                        }}
                                        render={({field}) => (
                                            <Form.Control
                                                {...field}
                                                type="text"
                                                isInvalid={errors.zip}
                                            />
                                        )}
                                    />
                                </Form.Group>
                            </div>
                        </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="border-0">
                    <LoadingButtonWithForm
                        isLoading={editLoading ? editLoading : addLoading}
                        name="Save"
                        form="company-status"
                    />
                </Modal.Footer>

            </Modal>
        </>
);
};

export default AddCompanyModal;